import type { Order } from '~/types/GraphQL';

declare global {
  interface Window {
    publitasTracker?: {
      publitasTrackEvent: (event: string, payload: any) => void;
    };
  }
}

export default () => {
    type Payload = {
      orderId: string;
      total: number;
      orderItems:
      {
        sku: string;
        name: string;
        price: number;
        quantity: number;
      }[];
    };

    const trackPublitasCheckout = (order: Order) => {
      const pbPayload: Payload = {
        orderId: order.id,
        total: (order.totalPrice.centAmount ?? '0') / 100,
        orderItems: (order.lineItems || []).map(item => ({
          sku: item.variant?.sku ?? '',
          name: item.name ?? '',
          price: (item.price.value.centAmount ?? '0') / 100,
          quantity: item.quantity ?? 0,
        })),
      };

      if (window.publitasTracker) {
        window.publitasTracker.publitasTrackEvent('checkout', pbPayload);

        return;
      }

      document.addEventListener('publitasTrackerReady', () => {
        window.publitasTracker?.publitasTrackEvent('checkout', pbPayload);
      });
    };

    return {
      trackPublitasCheckout,
    };
};
